import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=7803d7e9&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports